import React from 'react'
import { useField } from 'formik'
import * as Styled from './PhoneField.styled'
import { PhoneInput } from 'react-international-phone'
import { Colors } from 'styles'
import { FormHelperText } from '@material-ui/core'
import { CountrySelectorStyleProps } from 'react-international-phone/dist/components/CountrySelector/CountrySelector'

type Variant = 'default' | 'square'

interface VariantStyles {
  inputStyle: React.CSSProperties
  countrySelectorStyleProps: CountrySelectorStyleProps
}

const variants: Record<Variant, VariantStyles> = {
  default: {
    inputStyle: {
      width: '100%',
      fontSize: 18,
      fontWeight: 500,
      fontFamily: 'Inter',
      padding: '20px 14px',
      borderRadius: '0px 24px 24px 0px',
      border: `2px solid ${Colors.GREY[200]}`,
      borderLeftWidth: 0,
    },
    countrySelectorStyleProps: {
      style: {
        fontFamily: 'Inter',
      },
      buttonStyle: {
        fontSize: 18,
        fontWeight: 500,
        padding: '20px 14px',
        borderRadius: '24px 0px 0px 24px',
        border: `2px solid ${Colors.GREY[200]}`,
        borderRightWidth: 0,
      },
    },
  },
  square: {
    inputStyle: {
      width: '100%',
      fontSize: 24,
      fontWeight: 500,
      fontFamily: 'Inter',
      padding: '18.5px 14px',
      borderRadius: '0 4px 4px 0',
      border: `1px solid #EFEFEF`,
      borderLeftWidth: '0px',
      height: 'auto',
      marginTop: 0,
    },
    countrySelectorStyleProps: {
      style: {
        fontFamily: 'Inter',
      },
      buttonStyle: {
        fontSize: 18,
        fontWeight: 500,
        padding: '18.5px 14px',
        borderRadius: '4px 0 0 4px',
        border: `1px solid #EFEFEF`,
        borderRightWidth: '0px',
        height: '100%',
        backgroundColor: Colors.TEXT_DARK,
      },
    },
  },
}

interface TextFieldFieldProps {
  name: string
  variant?: Variant
}

const PhoneField: React.FC<TextFieldFieldProps> = ({
  name,
  variant = 'default',
}) => {
  const [field, meta, helpers] = useField(name)
  const styles = variants[variant]

  return (
    <Styled.Wrapper fullWidth>
      <Styled.StyledLabel htmlFor={name} darkMode>
        Telefone
      </Styled.StyledLabel>

      <PhoneInput
        name={name}
        inputStyle={styles.inputStyle}
        countrySelectorStyleProps={styles.countrySelectorStyleProps}
        placeholder="Telefone"
        defaultCountry="br"
        value={field.value}
        onChange={(phone) => helpers.setValue(phone)}
      />

      {meta.error && meta.touched && (
        <FormHelperText error>{meta.error}</FormHelperText>
      )}
    </Styled.Wrapper>
  )
}

export default PhoneField
